import { useEffect, useState } from "react";
import { useAppSelector } from "@/src/common/redux/store";
import { getColorScheme } from "@/src/common/store/general-selectors";

type ResolvedScheme = "light" | "dark";

function getSystemScheme(): ResolvedScheme {
	return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function useResolvedColorScheme(): ResolvedScheme {
	const colorScheme = useAppSelector(getColorScheme);
	const [systemScheme, setSystemScheme] = useState<ResolvedScheme>(getSystemScheme);

	useEffect(() => {
		if (colorScheme !== "system") return;
		const mql = window.matchMedia("(prefers-color-scheme: dark)");
		const onChange = (event: MediaQueryListEvent) => {
			setSystemScheme(event.matches ? "dark" : "light");
		};
		setSystemScheme(mql.matches ? "dark" : "light");
		mql.addEventListener("change", onChange);
		return () => mql.removeEventListener("change", onChange);
	}, [colorScheme]);

	return colorScheme === "system" ? systemScheme : colorScheme;
}
